import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWaveRound2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconWaveRound2"><Path d="M9.5 3C11.433 3 13 4.567 13 6.5V17.5C13 18.3284 13.6716 19 14.5 19C15.3284 19 16 18.3284 16 17.5V14.5C16 12.2909 17.7909 10.5 20 10.5H22V12.5H20C18.8954 12.5 18 13.3954 18 14.5V17.5C18 19.433 16.433 21 14.5 21C12.567 21 11 19.433 11 17.5V6.5C11 5.67157 10.3284 5 9.5 5C8.67157 5 8 5.67157 8 6.5V9C8 11.2091 6.20914 13 4 13H2V11H4C5.10457 11 6 10.1046 6 9V6.5C6 4.567 7.567 3 9.5 3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconWaveRound2;
